import { useMemo, useState } from "react";
import { Mail, MapPin, Phone, Heart } from "lucide-react";
import LegalPostModal from "@/components/LegalsModal";

export default function Footer() {
  const year = useMemo(() => new Date().getFullYear(), []);

  const [legalModalOpen, setLegalModalOpen] = useState(false);
  const [legalSlug, setLegalSlug] = useState("");
  const [legalTitle, setLegalTitle] = useState("");

  const openLegalModal = (slug, title) => {
    setLegalSlug(slug);
    setLegalTitle(title);
    setLegalModalOpen(true);
  };

  const closeLegalModal = () => {
    setLegalModalOpen(false);
    setLegalSlug("");
    setLegalTitle("");
  };

  return (
    <>
      <footer className="rz-footer" data-testid="footer">
        <div className="rz-shell rz-footer__inner">
          <div className="text-center md:text-left">
            <img
              src="/images/logo_alb_rezervix.png"
              alt="Rezervix"
              className="rz-logo rz-logo--footer"
            />
            <p>
              Construim prezență online pentru unități de cazare care își doresc
              mai multă expunere și rezervări directe.
            </p>
          </div>

          <div className="flex items-center gap-6 text-sm text-white/70">
            <button
              type="button"
              onClick={() => openLegalModal("termeni-si-conditii", "Termeni și condiții")}
              className="hover:text-white transition-colors"
            >
              Termeni și condiții
            </button>
            <button
              type="button"
              onClick={() =>
                openLegalModal(
                  "politica-de-confidentialitate",
                  "Politică de confidențialitate"
                )
              }
              className="hover:text-white transition-colors"
            >
              Politică de confidențialitate
            </button>
          </div>

          <div className="text-center md:text-left">
            <h4>Contact</h4>

            <a href="mailto:info@rezervix.ro" className="flex items-center gap-2">
              <Mail size={16} />
              info@rezervix.ro
            </a>

            <a href="tel:+40756515378" className="flex items-center gap-2">
              <Phone size={16} />
              0756515378
            </a>

            <p className="flex items-center gap-2">
              <MapPin size={16} />
              România
            </p>
          </div>
        </div>

        <div className="rz-shell rz-footer__bottom mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/50">
            © {year} Rezervix. Toate drepturile rezervate.
          </p>

          <p className="text-sm text-white/50 flex items-center gap-1">
            Creat cu <Heart className="w-4 h-4 text-white" /> în România.
          </p>
        </div>
      </footer>

      <LegalPostModal
        open={legalModalOpen}
        slug={legalSlug}
        fallbackTitle={legalTitle}
        onClose={closeLegalModal}
      />
    </>
  );
}